export class ContasReceberBulkRequest {
    public idsParcelas: number[] = [];
    public tipoProcessamentoRecorrencia: number = 1;
}
